const ARROW_SEPARATOR = ' \u27F6 '

/**
 * Join the parts with the " ⟶ " display separator, dropping empty/nullish ones.
 * Returns `undefined` when nothing remains. Shared so the "A ⟶ B" render is
 * defined once.
 */
export function joinWithArrow(
  ...parts: (string | null | undefined)[]
): string | undefined {
  const present = parts.filter(Boolean)
  return present.length ? present.join(ARROW_SEPARATOR) : undefined
}
